import { Button, DatePicker, Form, Select, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "../styles/Content.module.css";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Rectangle,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import moment from "moment"


const TotalOverview = ({branches, isAdmin, onFinishFilterTotalOverview, summaryTotals, userBranch}) => {
  return (
    <div className={styles.cardContent}>
      <div className={styles.filterForm}>
        <Form layout="inline" onFinish={onFinishFilterTotalOverview} initialValues={{location: userBranch, year: moment()}}>
          {isAdmin && (
            <Form.Item name="location">
              <Select
                className={styles.select}
                showSearch
                optionFilterProp="label"
                options={branches.map((item) => {
                  return { value: item.id, label: item.zone };
                })}
                placeholder="Todas las sucursales"
              />
            </Form.Item>
          )}
          <Form.Item name="year">
            <DatePicker.YearPicker placeholder="Seleccionar año" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ display: 'inline-flex', alignItems: 'center' }}>
              Buscar
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className={styles.chartContainer}>
        <p className={styles.chartTitle}>Total Órdenes</p>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart width={500} height={500} data={summaryTotals}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip
              contentStyle={{ borderRadius: '8px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
            />
            <Legend />

            <Bar
              dataKey="ordenes"
              fill="#FF671D"
              activeBar={<Rectangle fill="#FF671D" stroke="#e55a15" />}
              label={{ position: "centerTop", fill: "#FFF", fontSize: 11 }}
              radius={[4, 4, 0, 0]}
            />
            <Bar
              dataKey="ventas"
              fill="#585858"
              activeBar={<Rectangle fill="#585858" stroke="#444" />}
              label={{ position: "centerTop", fill: "#FFF", fontSize: 11 }}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TotalOverview;
